import { PropsWithChildren, useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { isTokenValid, resetTokens } from "../utils/tokenUtils";
import { type Role } from "../types/user";
import { useIsMobile } from "../hooks/useMediaQuery";

export const PublicRoute = () => {
  return (
    <div className="page public">
      <Outlet />
    </div>
  );
};

export const PrivateRoute = ({
  role,
  children,
}: PropsWithChildren<{ role: Role }>) => {
  const navigate = useNavigate();
  const isValid = isTokenValid(role);

  useEffect(() => {
    if (!isValid) {
      resetTokens();
      navigate("/", { replace: true });
    }
  }, [isValid]);

  return isValid ? (
    <div className={`page private ${role}`}>{children}</div>
  ) : null;
};

export const OnlyDesktopRoute = () => {
  const isMobile = useIsMobile();

  if (isMobile) return <p>PC로만 이용 가능한 기능입니다.</p>;
  return <Outlet />;
};
